import { useContext, useState, useEffect } from "react";
import { DasboardContext } from "../../context/dashboard-context";

import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import UserTable from "../../components/UserTable/UserTable";

import "./style.css";

const UsersList = () => {
  const tableRow = ["Kullanıcı Adı", "Kullanıcı Tipi", "Profil", "Raporlar"];
  const [tableData, setTableData] = useState([]);
  const { sidebarOpen, userInfo } = useContext(DasboardContext);

  async function getUser() {
    try {
      const response = await fetch(`https://app.vivasmartcare.com/api/users`);
      const users = await response.json();
      console.log(users);
      console.log(userInfo.company);

      if (userInfo.company !== "all") {
        const filteredUsers = users.filter(
          (user) => user.company === userInfo.company
        );
        setTableData(filteredUsers);
      } else {
        setTableData(users);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getUser();
  }, []);

  return (
    <>
      <Breadcrumb />
      <div
        className={`user-list-wrapper component-wrapper ${
          sidebarOpen ? "" : "close"
        }`}
      >
        <UserTable tableRow={tableRow} tableData={tableData} />
      </div>
    </>
  );
};

export default UsersList;
